import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SparkPlusDropdownComponent, SparkPlusDropdownToggle } from './dropdown.component';
import { SparkPlusDirectiveModule } from '@shared/directives/directives.module';



@NgModule({
  declarations: [
    SparkPlusDropdownComponent,
    SparkPlusDropdownToggle
  ],
  imports: [
    CommonModule,
    SparkPlusDirectiveModule
  ],
  exports: [
    SparkPlusDropdownComponent,
    SparkPlusDropdownToggle
  ]
})
export class SparkPlusDropdownModule { }
